export default class PreferenceCenter extends BaseComponent {
    initialize() {
        this.setupChevrons();
    }

    functions() {
        return {
            addSearch: term => this.addSearch(term),
            removeSearch: term => this.removeSearch(term)
        }
    }

    addSearch(term) {
        this.removeSearch(term);
        this.find('.child-holder')
            .filter((i, tag) => !$(tag).text().toLowerCase().includes(term.toLowerCase()))
            .attr('hidden', 'hidden');
        this.find('.tag-group').filter((i, group) => {
            return $(group).find('.child-holder:not([hidden])').length === 0
        }).attr('hidden', 'hidden');
        this.find('.preference-section').filter((i, section) => {
            return $(section).find('.tag-group:not([hidden])').length === 1
        }).find('.tag-group:not([hidden]) .chevron-holder .fa-chevron-down').each((i, element) => {
            let target = $(element)
            target.attr('class', 'fa fa-chevron-up');
            target.closest('.tag-group').find('.child-tags').show();
        })
    }

    removeSearch(term) {
        this.find('.tag-group').removeAttr('hidden');
        this.find('.child-holder').removeAttr('hidden');
    }

    setupChevrons() {
        $(this.component).on('click', '.chevron-holder .fa-chevron-down', event => {
            this.find('.chevron-holder .fa-chevron-up').click();
            let target = $(event.target);
            target.attr('class', 'fa fa-chevron-up');
            target.closest('.tag-group').find('.child-tags').show();
        });
        $(this.component).on('click', '.chevron-holder .fa-chevron-up', event => {
            let target = $(event.target);
            target.attr('class', 'fa fa-chevron-down');
            target.closest('.tag-group').find('.child-tags').hide();
        });
        $(this.component).on('click', '.toggle-category .fa-chevron-down', event => {
            let target = $(event.target);
            target.attr('class', 'fa fa-chevron-up');
            target.closest('.preference-section').addClass('closed')
            target.closest('.preference-section').find('.tag-groups').addClass('hidden-xs hidden-sm');
        });
        $(this.component).on('click', '.toggle-category .fa-chevron-up', event => {
            let target = $(event.target);
            target.attr('class', 'fa fa-chevron-down');
            target.closest('.preference-section').removeClass('closed')
            target.closest('.preference-section').find('.tag-groups').removeClass('hidden-xs hidden-sm');
        });
        $(this.component).on('click', '.tag-group-header .checkbox', event => {
            let target = $(event.target);
            let checked = target.prop('checked');
            target.closest('.tag-group').find('.child-tags .checkbox').prop('checked', checked);
        });
        $(this.component).on('click', '.child-holder .checkbox', event => {
            let target = $(event.target);
            let checked = target.prop('checked');
            this.find(`[name="${target.attr('name')}"]`).prop('checked', checked);
        });
    }

    acknowledge() {
        $.post('/acknowledge_preference_message');
        this.find('.notification').hide();
    }
}